
// 所处环境
// const formalEnvironment = false
const overallData = {
  process: process,
  // axiosUrl: formalEnvironment ? 'http://192.168.1.214/api' : 'http://39.104.55.191:8081/api' // 请求的访问前缀
  axiosUrl: process.env.VUE_APP_BASE_API // 请求的访问前缀
}
export default overallData
